import { css } from "styled-components";

export const bp = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 900,
  xl: 1100,
  xxl: 1280,
} as const;

export const formLabelCol = {
  xs: { span: 24 },
  sm: { span: 5 },
};

export const formWrapperCol = {
  xs: { span: 24 },
  sm: { span: 19 },
};

export const formOffsetCol = {
  xs: { span: 24, offset: 0 },
  sm: { span: 19, offset: 5 },
};

export const formLabelColWide = {
  xs: { span: 24 },
  sm: { span: 6 },
};

export const formWrapperColWide = {
  xs: { span: 24 },
  sm: { span: 18 },
};

export const formOffsetColWide = {
  xs: { span: 24, offset: 0 },
  sm: { span: 18, offset: 6 },
};

export const pageShellCss = css`
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  min-width: 0;
  min-height: 100%;
  margin-left: auto;
  margin-right: auto;
  align-self: center;
  padding: 48px 56px 56px;
  padding-left: max(56px, env(safe-area-inset-left));
  padding-right: max(56px, env(safe-area-inset-right));
  padding-bottom: max(56px, env(safe-area-inset-bottom));

  @media (max-width: 1280px) {
    padding: 32px 32px 40px;
    padding-left: max(32px, env(safe-area-inset-left));
    padding-right: max(32px, env(safe-area-inset-right));
  }

  @media (max-width: 1100px) {
    padding: 24px 20px 32px;
    padding-left: max(20px, env(safe-area-inset-left));
    padding-right: max(20px, env(safe-area-inset-right));
  }

  @media (max-width: 900px) {
    padding: 16px 16px 24px;
    padding-left: max(16px, env(safe-area-inset-left));
    padding-right: max(16px, env(safe-area-inset-right));
    min-height: calc(100dvh - 56px);
  }

  @media (max-width: 480px) {
    padding: 12px 12px 20px;
    padding-left: max(12px, env(safe-area-inset-left));
    padding-right: max(12px, env(safe-area-inset-right));
    padding-bottom: max(20px, env(safe-area-inset-bottom));
  }
`;

export const wrapRowCss = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  flex-wrap: wrap;
  min-width: 0;
`;

export const tableScrollCss = css`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  min-width: 0;

  .ant-table {
    min-width: 640px;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    vertical-align: middle;
  }

  @media (max-width: 480px) {
    .ant-table {
      min-width: 560px;
    }
  }
`;

export const dataTableCss = css`
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  th,
  td {
    text-align: inherit;
    vertical-align: middle;
  }

  th.is-center,
  td.is-center {
    text-align: center;
  }

  th.is-right,
  td.is-right {
    text-align: right;
  }
`;

export const kpiBreakCss = css`
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr !important;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr !important;
    gap: 12px;
  }
`;

export const twoColCss = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  min-width: 0;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const searchFieldCss = css`
  width: 240px;
  max-width: 100%;
  min-width: 0;

  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const fluidControlCss = css`
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;

export const stackRowCss = css`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 0;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const authPageCss = css`
  min-height: 100vh;
  min-height: 100dvh;
  padding: 48px 16px 32px;
  padding-top: max(32px, 10vh);
  padding-left: max(16px, env(safe-area-inset-left));
  padding-right: max(16px, env(safe-area-inset-right));
  padding-bottom: max(32px, env(safe-area-inset-bottom));

  @media (max-width: 640px) {
    padding: 24px 12px 20px;
    padding-left: max(12px, env(safe-area-inset-left));
    padding-right: max(12px, env(safe-area-inset-right));
  }
`;

export const authCardCss = css`
  width: 100%;
  max-width: 560px;
  padding: 48px 32px 24px;
  box-sizing: border-box;

  @media (max-width: 640px) {
    padding: 24px 16px 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }
`;

export const authFieldRowCss = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

export const authLabelCss = css`
  width: 140px;
  flex-shrink: 0;

  @media (max-width: 640px) {
    width: auto;
  }
`;

export const pageTitleCss = css`
  overflow-wrap: anywhere;

  @media (max-width: 640px) {
    font-size: 20px;
  }
`;
